import { render, staticRenderFns } from "./AlertAssignModal.vue?vue&type=template&id=bde69f2a&scoped=true&"
import script from "./AlertAssignModal.vue?vue&type=script&lang=js&"
export * from "./AlertAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertAssignModal.vue?vue&type=style&index=0&id=bde69f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde69f2a",
  null
  
)

export default component.exports